export enum DialogResultType {
  Ok = 1,
  Cancel,
  Yes,
  No,
  Delete,
}

export class DialogResult {
  ResultType: DialogResultType;
  ResultData: any;
}
